import {LineupPlayers as CFBClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/cfb/classic';
import {LineupPlayers as CFBShowDownLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/cfb/showdown';

import {LineupPlayers as MLBClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mlb/classic';
import {LineupPlayers as MLBShowDownLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mlb/showdown';
import {LineupPlayers as MLBTiersLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mlb/tiers';

import {LineupPlayers as NBAClassicLineupPlayers} from './nba/classic';
import {LineupPlayers as NBAShowDownLineupPlayers} from './nba/showdown';
import {LineupPlayers as NBATiersLineupPlayers} from './nba/tiers';

import {LineupPlayers as NFLClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nfl/classic';
import {LineupPlayers as NFLShowDownLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nfl/showdown';
import {LineupPlayers as NFLTiersLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nfl/tiers';

import {LineupPlayers as LOLClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/lol/classic';

import {LineupPlayers as NHLClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nhl/classic';
import {LineupPlayers as NHLShowDownLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nhl/showdown';
import {LineupPlayers as NHLTiersLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nhl/tiers';

import {LineupPlayers as GOLFClassicLineupPlayers} from './golf/classic';
import {LineupPlayers as GOLFTiersLineupPlayers} from './golf/tiers';

import {LineupPlayers as NASCARClassicLineupPlayers} from './nascar/classic';

import {LineupPlayers as MMAClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mma/classic';
import {LineupPlayers as MMAShowDownLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mma/showdown';
import {LineupPlayers as TennisClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/tennis/classic';
import {LineupPlayers as F1ClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/f1/classic';

const Factory = {
    getComponent(sportConfig) {
        if (sportConfig.isSportNba()) {
            if (sportConfig.isGameTypeClassic()) {
                return NBAClassicLineupPlayers;
            } else if (sportConfig.isGameTypeShowDown()) {
                return NBAShowDownLineupPlayers;
            } else if (sportConfig.isGameTypeTiers()) {
                return NBATiersLineupPlayers;
            }
        } else if (sportConfig.isSportNhl()) {
            if (sportConfig.isGameTypeClassic()) {
                return NHLClassicLineupPlayers;
            } else if (sportConfig.isGameTypeShowDown()) {
                return NHLShowDownLineupPlayers;
            } else if (sportConfig.isGameTypeTiers()) {
                return NHLTiersLineupPlayers;
            }
        } else if (sportConfig.isSportCfb()) {
            if (sportConfig.isGameTypeClassic()) {
                return CFBClassicLineupPlayers;
            } else if (sportConfig.isGameTypeShowDown()) {
                return CFBShowDownLineupPlayers;
            }
        } else if (sportConfig.isSportMlb()) {
            if (sportConfig.isGameTypeClassic()) {
                return MLBClassicLineupPlayers;
            } else if (sportConfig.isGameTypeShowDown()) {
                return MLBShowDownLineupPlayers;
            } else if (sportConfig.isGameTypeTiers()) {
                return MLBTiersLineupPlayers;
            }
        } else if (sportConfig.isSportNfl()) {
            if (sportConfig.isGameTypeClassic()) {
                return NFLClassicLineupPlayers;
            } else if (sportConfig.isGameTypeShowDown()) {
                return NFLShowDownLineupPlayers;
            } else if (sportConfig.isGameTypeTiers()) {
                return NFLTiersLineupPlayers;
            }
        } else if (sportConfig.isSportMma()) {
            if (sportConfig.isGameTypeShowDown()) {
                return MMAShowDownLineupPlayers;
            }
            return MMAClassicLineupPlayers;
        } else if (sportConfig.isSportGolf()) {
            if (sportConfig.isGameTypeClassic()) {
                return GOLFClassicLineupPlayers;
            } else if (sportConfig.isGameTypeShowDown()) {
                return GOLFClassicLineupPlayers;
            } else if (sportConfig.isGameTypeTiers()) {
                return GOLFTiersLineupPlayers;
            }
        } else if (sportConfig.isSportNascar()) {
            return NASCARClassicLineupPlayers;
        } else if (sportConfig.isSportLol()) {
            return LOLClassicLineupPlayers;
        } else if (sportConfig.isSportTennis()) {
            return TennisClassicLineupPlayers;
        } else if (sportConfig.isSportF1()) {
            return F1ClassicLineupPlayers;
        }
    },
};

export {Factory};
